import React from 'react';
import { useNavigate } from 'react-router-dom';  // Add this import
import { Box, AppBar, Toolbar, Typography, Container, Button } from '@mui/material';
import Sidebar from './Sidebar';
import { motion } from 'framer-motion';
import AnimatedHeaderBackground from './ui/EnhancedUIComponents';

const Layout = ({ children, user, onLoginClick }) => {
  const navigate = useNavigate();  // Add this
  console.log("Layout rendering with:", { user, children });
  
  const renderSidebar = () => {
    try {
      return <Sidebar user={user} onLoginClick={onLoginClick} />;
    } catch (error) {
      console.error("Sidebar failed to render:", error);
      return (
        <Box sx={{ width: 240, bgcolor: '#e3f2fd' }}>
          <Typography p={2}>Menu</Typography>
        </Box>
      );
    }
  };
  
  return (
    <Box 
      sx={{ 
        display: 'flex',
        minHeight: '100vh',
        width: '100vw',
        bgcolor: '#f5f5f5'
      }}
    >
      {renderSidebar()}
      
      <Box 
        component="main" 
        sx={{ 
          flexGrow: 1,
          display: 'flex',
          flexDirection: 'column',
          minHeight: '100vh'
        }}
      >
        <AppBar 
          position="static" 
          sx={{ 
            background: 'linear-gradient(135deg, #1e3c72 0%, #2a5298 100%)',
            boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
            position: 'relative',
            overflow: 'hidden'
          }}
        >
          <Box sx={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0 }}>
            <AnimatedHeaderBackground />
          </Box>
          
          <Toolbar sx={{ position: 'relative', zIndex: 1 }}>
            <Typography 
              variant="h6" 
              onClick={() => navigate('/')}  // Add this
              sx={{ 
                flexGrow: 1, 
                fontWeight: 'bold',
                color: 'white',
                textShadow: '0 2px 4px rgba(0,0,0,0.2)',
                cursor: 'pointer',  // Add this
                '&:hover': {  // Add this
                  opacity: 0.9
                }
              }}
            >
              DIYMind
            </Typography>
            {user ? (
              <Typography 
                sx={{
                  color: 'white',
                  background: 'rgba(255,255,255,0.2)',
                  px: 2,
                  py: 1,
                  borderRadius: '8px',
                  backdropFilter: 'blur(8px)'
                }}
              >
                Welcome back!
              </Typography>
            ) : (
              <Button 
                variant="contained"
                onClick={onLoginClick}
                sx={{
                  bgcolor: 'white',
                  color: 'primary.main',
                  boxShadow: '0 4px 14px rgba(0,0,0,0.15)',
                  '&:hover': {
                    bgcolor: 'white',
                    transform: 'translateY(-2px)',
                    boxShadow: '0 6px 20px rgba(0,0,0,0.2)'
                  },
                  transition: 'all 0.3s'
                }}
              >
                Login
              </Button>
            )}
          </Toolbar>
        </AppBar>
        
        <Container 
          maxWidth="lg" 
          sx={{ 
            mt: 3,
            mb: 3,
            flexGrow: 1,
            display: 'flex',
            flexDirection: 'column'
          }}
        >
          {children ? (
            <motion.div
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.4 }}
              style={{ display: 'flex', flexDirection: 'column', flexGrow: 1 }}
            >
              {children}
            </motion.div>
          ) : (
            <Box 
              sx={{ 
                flexGrow: 1,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}
            >
              <motion.div
                animate={{ 
                  opacity: [0.5, 1, 0.5],
                  scale: [0.98, 1, 0.98]
                }}
                transition={{ 
                  repeat: Infinity, 
                  duration: 1.5 
                }}
              >
                <Typography variant="h5" color="text.secondary">
                  Loading...
                </Typography>
              </motion.div>
            </Box>
          )}
        </Container>
      </Box>
    </Box>
  );
};

export default Layout;

